<template>
  <div>
    <ForeignOrganization
      :v="v"
      :is-alternative-service-edit="isAlternativeServiceEdit"
      :is-surcharge="isSurcharge"
      translationKey="noticeRecovery.applicant.foreignOrg"
		>
			<slot></slot>
		</ForeignOrganization>

    <TrusteeView
      :v="v.trustee"
      label="Сведения о представителе иностранного юридического лица"
      :role-type="roleValue"
      :statement-type="statementType"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { required, requiredIf } from 'vuelidate/lib/validators';

import TrusteeView, {
  trusteeModel,
  trusteeValidate,
} from '@/components/services/elements/TrusteeView';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from '../ForeignOrganization';
import { Role } from '@/utils/dictionaries';

export const manualForeignOrganizationModel = {
  ...foreignOrganizationModel,
  trustee: cloneDeep(trusteeModel),
};

export const getManualForeignOrganizationValidation = (
  foreignOrganization,
  isAlternativeServiceEdit
) => ({
  ...foreignOrganizationValidation,
  trustee: deepmerge(trusteeValidate(foreignOrganization.trustee), {
    email: {
      required,
    },
    phone: {
      required,
    },
    documents: {
      authorityDocument: {
        file: {
          required: requiredIf(() => isAlternativeServiceEdit),
        },
      },
    },
  }),
});

export default {
  name: 'ManualForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
      required: true,
    },
    isSurcharge: {
      type: Boolean,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  components: { ForeignOrganization, TrusteeView },
  data: () => ({
    roleValue: Role.FOREIGN_ORGANIZATION,
  }),
};
</script>
